<div #capture>
    <ngx-scanner-qrcode class="m-center" #scanner (data)="onSuccess($event)"></ngx-scanner-qrcode>
</div>
